import Snackbar from '@material-ui/core/Snackbar'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import NotificationContent from './NotificationContent'

import { useNotification } from '../hooks'
import { ERROR_NOTIFICATION, SUCCESS_NOTIFICATION } from '../slice'

const getVariant = type => {
  switch (type) {
    case ERROR_NOTIFICATION:
      return 'error'
    case SUCCESS_NOTIFICATION:
      return 'success'
    default:
      return 'info'
  }
}

const getDuration = type => {
  switch (type) {
    case ERROR_NOTIFICATION:
      return 3000
    case SUCCESS_NOTIFICATION:
      return 5000
    default:
      return 3000
  }
}

export const Notification = ({ isOpen, notification, onClear, onClose }) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={isOpen}
      autoHideDuration={getDuration(notification.type)}
      onClose={onClose}
      onExited={onClear}
    >
      <NotificationContent
        image={notification.image}
        message={notification.message}
        onClose={onClose}
        variant={getVariant(notification.type)}
      />
    </Snackbar>
  )
}

Notification.propTypes = {
  isOpen: PropTypes.bool,
  notifiation: PropTypes.shape({
    id: PropTypes.string,
    message: PropTypes.string,
    image: PropTypes.oneOf([
      undefined,
      'aubergines',
      'carrots',
      'leeks',
      'mushrooms',
      'onion',
      'orange',
      'peas',
      'potato',
      'thyme',
      'tomato',
    ]),
    type: PropTypes.oneOf(['info', 'error', 'success']),
  }),
  onClear: PropTypes.func,
  onClose: PropTypes.func,
}

const NotificationContainer = () => {
  const { clearNotification, queue } = useNotification()

  const [isOpen, setIsOpen] = useState(false)
  const [queueSize, setQueueSize] = useState(0)
  const [openNotification, setNotification] = useState({
    id: undefined,
    message: '',
    type: 'info',
  })

  useEffect(() => {
    const processQueue = () => {
      if (!queue.length) return
      if (isOpen) {
        setIsOpen(false)
      } else {
        let notification = queue[0]
        setNotification(notification)
        setIsOpen(true)
      }
    }

    if (queue.length !== queueSize) {
      setQueueSize(queue.length)
      processQueue()
    }
  }, [queue, queueSize, isOpen])

  const handleClose = (e, reason) => {
    if (reason === 'clickaway') return
    setIsOpen(false)
  }

  const clear = () => {
    let { id } = openNotification
    clearNotification({ id })
  }

  return (
    <Notification
      isOpen={isOpen}
      notification={openNotification}
      onClear={clear}
      onClose={handleClose}
    />
  )
}

export default NotificationContainer
